/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  Snackbar,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import {
  MenuProps,
  PaperComponent,
  convertNumbersToStrings,
} from "../../../../utils/constants";

const defaultValue = {
  tinh: "",
  huyen: "",
  ma: "",
  madinhdanh: "",
  ten: "",
  ghichu: null,
  sothutu: 1,
  dientich: 0,
};

const CRUDCapPhuong = ({
  data,
  open,
  onClose,
  onSubmitPhuong,
  title,
  validationErrors,
  dataOptionProvince,
  dataOptionDistrict,
}) => {
  const [errors, setErrors] = useState({
    huyen: "",
    ma: "",
    madinhdanh: "",
    ten: "",
    sothutu: 1,
    error: "",
  });
  const [dataState, setDataState] = useState(defaultValue);
  const axiosPrivateInstance = useAxiosPrivate();
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [districtState, setDistrictState] = useState();
  const formRef = useRef(null);
  const [isError, setIsError] = useState(false);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    convertNumbersToStrings(_data);
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    onSubmitPhuong(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };
  const fetchDataDistrict = async (tinh) => {
    try {
      const response = await axiosPrivateInstance.get(
        "tinh/" + tinh + "/huyen"
      );
      setDistrictState(response.data);
      setDataState((prev) => {
        return {
          ...prev,
          huyen: "",
        };
      });
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
  };
  const handleChangeProvince = (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        tinh: value,
      };
    });
    fetchDataDistrict(value);
  };
  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        huyen: value,
      };
    });
  };
  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (data?.id) {
      let newData = data;
      setDataState(newData);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      setDistrictState(dataOptionDistrict);
      setErrors([]);
    }
  }, [open]);

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };
  return (
    <>
      <Dialog
        // fullScreen
        open={open}
        PaperComponent={PaperComponent}
      >
        {/* Form chỉnh sửa tạo mới giá đất */}
        <form ref={formRef} method="post" encType="multipart/form-data">
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2 }}>
            {title ? title : "Đơn ị hành chính cấp Phường/Xã"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {alert.alert && (
              <Snackbar
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={alert.alert}
                onClose={handleCloseAlert}
              >
                <Alert onClose={handleCloseAlert} severity={alert.type}>
                  {alert.message}
                </Alert>
              </Snackbar>
            )}
            <Box sx={{ p: 1 }}>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              <Grid container spacing={2} sx={{ textAlign: "left" }}>
                <Grid item xs={12} md={6} lg={6}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Tỉnh/Thành <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      sx={{ padding: "0.75rem" }}
                      value={dataState.tinh || ""}
                      required
                      displayEmpty
                      name="tinh"
                      MenuProps={MenuProps}
                      error={errors ? !!errors.tinh : false}
                      onFocus={() => {
                        setErrors({
                          ...errors,
                          tinh: "",
                        });
                      }}
                      onChange={handleChangeProvince}
                    >
                      <MenuItem value={""}>-- Chọn tỉnh thành --</MenuItem>
                      {dataOptionProvince &&
                        dataOptionProvince?.length > 0 &&
                        dataOptionProvince.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item?.ten}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors.tinh && (
                      <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                        {errors.tinh}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Quận/Huyện <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      sx={{ padding: "0.75rem" }}
                      value={dataState.huyen || ""}
                      required
                      displayEmpty
                      name="huyen"
                      MenuProps={MenuProps}
                      error={errors ? !!errors.huyen : false}
                      onFocus={() => {
                        setErrors({
                          ...errors,
                          huyen: "",
                        });
                      }}
                      onChange={handleChangeDistrict}
                    >
                      <MenuItem value={""}>-- Chọn Phường/Xã --</MenuItem>
                      {districtState &&
                        districtState?.length > 0 &&
                        districtState.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item?.ten}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors.huyen && (
                      <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                        {errors.huyen}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Mã Phường/Xã <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={dataState.ma}
                    error={errors ? !!errors.ma : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        ma: "",
                      });
                    }}
                    placeholder="Nhập mã Phường/Xã"
                    helperText={errors.ma}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("ma")}
                    name="ma"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Mã định danh <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={dataState.madinhdanh}
                    error={errors ? !!errors.madinhdanh : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        madinhdanh: "",
                      });
                    }}
                    placeholder="Nhập mã định danh"
                    helperText={errors.madinhdanh}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("madinhdanh")}
                    name="madinhdanh"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Tên Phường/Xã <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={dataState.ten}
                    error={errors ? !!errors.ten : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        ten: "",
                      });
                    }}
                    placeholder="Nhập tên Phường/Xã"
                    helperText={errors.ten}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("ten")}
                    name="ten"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Ghi chú
                  </Typography>
                  <TextField
                    value={dataState.ghichu}
                    placeholder="Nhập ghi chú"
                    helperText={errors.ghichu}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("ghichu")}
                    name="ghichu"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Số thứ tự
                  </Typography>
                  <TextField
                    value={dataState.sothutu}
                    name="sothutu"
                    type="number"
                    error={errors ? !!errors.sothutu : false}
                    placeholder="Nhập số thứ tự"
                    helperText={errors.sothutu}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("sothutu")}
                    inputProps={{ pattern: "[0-9]*" }}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Diện tích tự nhiên
                  </Typography>
                  <TextField
                    value={dataState.dientich}
                    name="dientich"
                    type="number"
                    error={errors ? !!errors.dientich : false}
                    placeholder="Nhập diện tích tự nhiên"
                    helperText={errors.dientich}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("dientich")}
                    inputProps={{ pattern: "[0-9]*" }}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

function validateOBJ(gd) {
  return {
    tinh: !validateRequired(gd.tinh) ? "Tên Tỉnh/Thành không được trống" : "",
    huyen: !validateRequired(gd.huyen) ? "Tên Quận/Huyện không được trống" : "",
    ten: !validateRequired(gd.ten) ? "Tên Phường/Xã không được trống" : "",
    ma: !validateRequired(gd.ma) ? "Mã Phường/Xã không được trống" : "",
    madinhdanh: !validateRequired(gd.madinhdanh)
      ? "Mã định danh không được trống"
      : "",
    sothutu: !validateRequired(gd.sothutu)
      ? "Số thứ tự không được trống. Phải là dạng số"
      : "",
    dientich: !validateRequired(gd.dientich) ? "Diện tích phải là dạng số" : "",
  };
}

export default CRUDCapPhuong;
